




































































































































import {Component, Vue} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import {MOBILE_PHONE_REGEX} from "@/shared/constant";
import {register} from "@/modules/auth/service";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import WardSelector from "@/modules/regions/WardSelector/index.vue";

const form = {
    email: undefined,
    fullName: undefined,
    phoneNumber: undefined,
    identityCard: undefined,
    contact: undefined,
    billAddress: undefined,
    provinceId: undefined,
    districtId: undefined,
    wardId: undefined,
    address: undefined
}

@Component({
    name: "Register",
    components: {WardSelector, DistrictSelector, AInputCustom, ProvinceSelector}
})
export default class extends Vue {
    form = { ...form };
    isSubmitting = false;

    private rules = {
        email: [{ required: true, type: "email", message: "Nhập email", trigger: "blur" }],
        phoneNumber: [
            { required: true, message: "Nhập số điện thoại", trigger: "blur" },
            { pattern: new RegExp(MOBILE_PHONE_REGEX), message: "Số điện thoại không hợp lệ", trigger: "blur" }
        ],
        fullName: [{ required: true, message: "Nhập họ tên", trigger: "blur" }],
        identityCard: [{ required: false, message: "Chọn phường/xã", trigger: "blur" }],
        contact: [{ required: false, message: "Chọn phường/xã", trigger: "blur" }],
        billAddress: [{ required: false, message: "Chọn phường/xã", trigger: "blur" }],
        provinceId: [{ required: true, message: "Chọn tỉnh/thành", trigger: "blur" }],
        districtId: [{ required: true, message: "Chọn quận/huyện", trigger: "blur" }],
        wardId: [{ required: true, message: "Chọn phường/xã", trigger: "blur" }],
        address: [{ required: true, message: "Nhập địa chỉ", trigger: "blur" }]
    };

    // private passwordValidator(rule: any, value: any, callback: Function) {
    //     if (value === "") {
    //         callback(new Error("Nhập mật khẩu"));
    //     } else {
    //         if (this.form.passwordConfirm !== "") {
    //             (this.$refs.formRegister as FormModel).validateField("passwordConfirm", () => 1);
    //         }
    //         callback();
    //     }
    // }
    //
    // private passwordConfirmValidator(rule: any, value: any, callback: Function) {
    //     if (value === "") {
    //         callback(new Error("Nhập lại mật khẩu"));
    //     } else if (value !== this.form.password) {
    //         callback(new Error("Mật khẩu không khớp"));
    //     } else {
    //         callback();
    //     }
    // }

    private onSubmit() {
        (this.$refs.formRegister as FormModel).validate(async valid => {
            if (!valid) return;
            this.isSubmitting = true;
            try {
                await register(this.form);
                this.$notification.success({
                    message: "Thành công",
                    description: "Đăng ký thành công, nhân viên CSKH sẽ liên hệ đến quý khách trong thời gian sớm nhất"
                })
                this.resetForm();
            } catch (e) {
                this.$notification.error({
                    message: "Thất bại",
                    description: e?.response?.data?.message || `Đăng ký không thành công, vui lòng thử lại sau`
                })
            } finally {
                this.isSubmitting = false;
            }
        })
    }

    resetForm() {
        this.form = { ...form };
    }
}
